export const enMessages = {
  "app.nav.calendar": "Calendar",
  "app.nav.analytics": "Analytics",
  "app.nav.circles": "Circles",
  "app.nav.settings": "Settings",
  "app.page.profile": "My Profile",
  "app.userMenu.open": "Open user menu",
  "app.userMenu.profile": "My Profile",
  "app.userMenu.signOut": "Sign Out",
  "app.userMenu.signingOut": "Signing out…",
  "app.feedback.title": "Feedback",
  "app.feedback.send": "Send feedback",
  "auth.back": "Back",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.securityCheckFailed": "Security check failed. Please refresh the page.",
  "auth.securityCheckFailedCookies": "Security check blocked. If your browser blocks cookies, try Google or passkey sign-in, or allow cookies for this site.",
  "auth.unexpected": "An unexpected error occurred.",
  "auth.login.title": "Welcome back",
  "auth.login.subtitle": "Sign in to your account",
  "auth.login.missingCredentials": "Please enter both email and password.",
  "auth.login.forgotPassword": "Forgot password?",
  "auth.login.keepSignedIn": "Keep me signed in",
  "auth.login.submit": "Sign in",
  "auth.login.submitting": "Signing in...",
  "auth.login.divider": "or continue with",
  "auth.login.google": "Continue with Google",
  "auth.login.passkey": "Passkey",
  "auth.login.noAccount": "Don't have an account?",
  "auth.login.signUp": "Sign up",
  "auth.login.googleDisabled": "Google sign-in is not enabled yet. Please use email and password for now.",
  "auth.login.invalidCredentials": "Invalid login credentials.",
  "auth.register.title": "Create account",
  "auth.register.subtitle": "Get started with Office Rhythm",
  "auth.register.firstName": "First name",
  "auth.register.lastName": "Last name",
  "auth.register.missingFields": "Please fill in all fields.",
  "auth.register.securityMissing": "Please complete the security check.",
  "auth.register.securityConfigMissing": "Security configuration missing. Contact support.",
  "auth.register.submit": "Create Account",
  "auth.register.submitting": "Creating...",
  "auth.register.google": "Continue with Google",
  "auth.register.emailDivider": "or use email",
  "auth.register.gmailPromptTitle": "Use Google for faster setup",
  "auth.register.gmailPromptDesc": "Because this is a Gmail address, Google can securely fill your name and profile photo for Office Rhythm.",
  "auth.register.gmailPromptCta": "Continue with Google",
  "auth.register.gmailPromptDismiss": "Use password instead",
  "auth.register.gmailPromptSubmit": "For Gmail, continue with Google or choose \"Use password instead\".",
  "auth.register.hasAccount": "Already have an account?",
  "auth.register.signIn": "Sign in",
  "auth.register.legalPrefix": "By signing up, you agree to our",
  "auth.register.terms": "Terms",
  "auth.register.acceptableUse": "Acceptable Use",
  "auth.register.legalAnd": "and",
  "auth.register.privacy": "Privacy Policy",
  "auth.password.minLength": "Password must be at least 8 characters.",
  "auth.password.uppercase": "Must include at least one uppercase letter.",
  "auth.password.number": "Must include at least one number.",
  "auth.password.special": "Must include at least one special character.",
  "auth.password.checkLength": "8+ characters",
  "auth.password.checkUppercase": "Uppercase letter",
  "auth.password.checkNumber": "Number",
  "auth.password.checkSpecial": "Special character",
  "settings.nav.aria": "Settings sections",
  "settings.nav.officeGoal": "Office goal",
  "settings.nav.general": "General",
  "settings.nav.appearance": "Appearance",
  "settings.nav.gamification": "Gamification",
  "settings.nav.dayTypes": "Day types",
  "settings.nav.integrations": "Integrations",
  "settings.nav.notifications": "Notifications",
  "settings.nav.workHours": "Work hours",
  "settings.nav.privacy": "Privacy",
  "settings.nav.danger": "Danger zone",
  "dashboard.nav.previousMonth": "Previous month",
  "dashboard.nav.previousPeriod": "Previous period",
  "dashboard.nav.nextMonth": "Next month",
  "dashboard.nav.nextPeriod": "Next period",
  "dashboard.calendar.weekdaysAria": "Days of the week",
  "dashboard.calendar.loading": "Loading calendar data...",
  "dashboard.calendar.updating": "Updating calendar",
  "dashboard.refresh.syncing": "Syncing...",
  "dashboard.refresh.release": "Release to refresh",
  "dashboard.refresh.pull": "Pull to refresh",
  "dashboard.dialog.cancel": "Cancel",
  "dashboard.dialog.delete": "Delete",
  "dashboard.dialog.remove": "Remove",
  "dashboard.dialog.keepEvent": "No, keep it",
  "dashboard.dialog.deleteTitle": "Are you absolutely sure?",
  "dashboard.dialog.deleteHiddenDescription": "Delete event confirmation",
  "dashboard.dialog.removeTitle": "Remove event?",
  "dashboard.dialog.removeHiddenDescription": "Remove event confirmation",
  "dashboard.goalProgress.title": "Goal Progress",
  "dashboard.goalProgress.titleWithPeriod": "Goal Progress - {period}",
  "goal.progress.period.week": "Week",
  "goal.progress.period.month": "Month",
  "goal.progress.period.quarter": "Quarter",
  "goal.progress.viewPeriod.week": "week",
  "goal.progress.viewPeriod.month": "month",
  "goal.progress.viewPeriod.quarter": "quarter",
  "goal.progress.viewContext": "This {viewPeriod}: {count} office day(s)",
  "goal.progress.viewAttendance": "This {viewPeriod}: {pct}% attendance",
  "goal.progress.periodAttendance": "{pct}% attendance · {confirmed}/{total} office days",
  "goal.progress.settingsContext": "{period} goal: {confirmed}/{target} office days",
  "goal.progress.settingsContextMet": "{period} goal met ({confirmed}/{target} office days)",
  "goal.progress.headline.viewOnly": "{pct}% attendance this {viewPeriod} · {confirmed} office day(s)",
  "goal.progress.headline.aligned": "{pct}% attendance · {confirmed} of {goal} min days",
  "goal.progress.headline.settingsMet": "{period} goal met ({confirmed}/{target} office days)",
  "goal.progress.marker.viewTarget": "Target for this {viewPeriod}: {goal} office days",
  "goal.progress.compact.viewStats": "{confirmed}/{goal} this {viewPeriod}",
  "rhythmIntelligence.pace.onTrack": "{period} pace: On track ({confirmed}/{target})",
  "rhythmIntelligence.pace.ahead": "{period} pace: Ahead ({confirmed}/{target})",
  "rhythmIntelligence.pace.behind": "{period} pace: Behind ({confirmed}/{target})",
  "rhythmIntelligence.pace.met": "{period} goal met ({confirmed}/{target})",
  "rhythmIntelligence.pace.detailHealthy": "A lighter week still fits your goal — alternating is fine.",
  "rhythmIntelligence.pace.detailBehind": "{remaining} more office day(s) needed this period.",
  "rhythmIntelligence.pickCountOne": "1 pick ready",
  "rhythmIntelligence.pickCountMany": "{count} picks ready",
  "rhythmIntelligence.noPicks": "No picks needed right now.",
  "rhythmIntelligence.summary.met": "You've met your {period} goal. Enjoy the flexibility.",
  "rhythmIntelligence.summary.onTrackEmpty": "Your {period} pace is on track. No picks needed right now.",
  "rhythmIntelligence.summary.onTrack": "On track — these picks balance your {period} goal and recovery.",
  "rhythmIntelligence.summary.ahead": "Ahead of pace — picks favor lighter, well-spaced days.",
  "rhythmIntelligence.summary.behind": "Behind pace — picks help you catch up without burning out.",
  "analytics.settingsProgress.week": "{period} progress: {confirmed} of {goal} days",
  "analytics.settingsProgress.percent": "{period} progress: {pct}%",
  "analytics.settingsProgress.namedMonth": "{month} progress: {pct}%",
  "analytics.settingsProgress.currentWeek": "This week: {confirmed} of {goal} days",
  "onboarding.wizard.title": "Onboarding Wizard",
  "onboarding.wizard.description": "Complete your profile and set your workspace preferences.",
  "onboarding.step.profile": "Profile",
  "onboarding.step.officeGoal": "Office Goal",
  "onboarding.step.ai": "AI Assistant",
  "onboarding.step.notifications": "Notifications",
  "onboarding.step1.title": "Tell us about yourself",
  "onboarding.step2.title": "Set your office goal",
  "onboarding.step3.title": "AI-powered suggestions",
  "onboarding.step4.title": "Stay in the loop",
  "onboarding.firstName": "First name",
  "onboarding.lastName": "Last name",
  "onboarding.birthday": "Birthday",
  "onboarding.placeholder.firstName": "Jane",
  "onboarding.placeholder.lastName": "Doe",
  "onboarding.month": "Month",
  "onboarding.day": "Day",
  "onboarding.goalPeriod": "Goal period",
  "onboarding.period.weekly": "Weekly",
  "onboarding.period.monthly": "Monthly",
  "onboarding.period.quarterly": "Quarterly",
  "onboarding.officePresenceTarget": "Office presence target",
  "onboarding.daysPerWeek": "Days per week",
  "onboarding.goal.noPresence": "No Presence",
  "onboarding.goal.minimal": "Minimal",
  "onboarding.goal.lightHybrid": "Light Hybrid",
  "onboarding.goal.balanced": "Balanced",
  "onboarding.goal.highPresence": "High Presence",
  "onboarding.goal.fullPresence": "Full Presence",
  "onboarding.daysPerWeekLabel": "{count, plural, one {# day per week} other {# days per week}}",
  "onboarding.calendarYear": "Calendar year",
  "onboarding.naturalYear": "Natural year",
  "onboarding.fiscalYear": "Fiscal year",
  "onboarding.fiscalStartsIn": "Fiscal year starts in",
  "onboarding.ai.title": "Hybrid Work Coach",
  "onboarding.ai.description": "Analyzes your work patterns and marks ★ Rhythm Intelligence picks directly on your calendar.",
  "onboarding.ai.pattern": "Pattern recognition",
  "onboarding.ai.patternDesc": "Learns from your past attendance.",
  "onboarding.ai.smart": "Smart suggestions",
  "onboarding.ai.smartDesc": "Recommends days based on team overlap.",
  "onboarding.ai.goal": "Goal optimization",
  "onboarding.ai.goalDesc": "Helps you hit your target effortlessly.",
  "onboarding.ai.settingsNote": "You can change this anytime in Settings.",
  "onboarding.notif.smartReminder": "Smart Reminder",
  "onboarding.notif.smartReminderDesc": "A daily anchor at your preferred time on workdays.",
  "onboarding.notif.digest": "Strategic Digest",
  "onboarding.notif.digestDesc": "A weekly recap of attendance and goal progress.",
  "onboarding.allSet.title": "All set.",
  "onboarding.allSet.description": "Your workspace is ready. You can always update these preferences later.",
  "onboarding.exploreFirst": "Explore calendar first",
  "onboarding.back": "Back",
  "onboarding.continue": "Continue",
  "onboarding.saving": "Saving…",
  "onboarding.getStarted": "Get started",
  "onboarding.reminder.title": "Finish setup",
  "onboarding.reminder.description": "— set your office goal and preferences when you're ready.",
  "onboarding.reminder.cta": "Continue",
  "onboarding.toast.welcome.title": "Welcome to Office Rhythm!",
  "onboarding.toast.welcome.description": "Your workspace is ready.",
  "onboarding.toast.failed.title": "Setup failed",
  "onboarding.toast.failed.description": "An unexpected error occurred during onboarding.",
} as const;

export type MessageId = keyof typeof enMessages;
